<template>
  <div class="application-form qualification-step">
    <ProfessionalQualifications :profile="profile" :withComponents="false" />

    <v-btn :color="themes.candidate.light.primaryActionButton" @click="$emit('input')" block>
      Save
    </v-btn>
  </div>
</template>

<script>
import ProfessionalQualifications from '@/components/candidate/profile/edit/qualifications/ProfessionalQualifications'

export default {
  components: { ProfessionalQualifications },
  props: { profile: { type: Object, required: true } },
}
</script>
